export const titleTagSuffix = " | Alliance for a Healthier Generation";
